import { Questions } from './class/Questions';
import { VideoPlayerService } from '../../../state';

export enum Zone {
  /**
   * Describe the zone where film review presenter should not be shown
   */
  Void,
  /**
   * Describe the zone where a hint presentation should be shown
   * on both mobile and desktop view
   */
  Hint,
  /**
   * Describe the zone where video credit rolls.
   * On mobile, the hint should continue be shown concurrently with WatchNextOverlay.
   * on desktop, it should automatically expand and show questionnaire presenter, collapsing WatchNextOverlay
   */
  Credit,
  /**
   * Describe the zone where video has completed playback
   * On mobile, the hint should continue be shown concurrently with WatchNextOverlay.
   * On desktop, it should automatically expand and show questionnaire presenter, collapsing WatchNextOverlay
   */
  Completed,
}

export interface FilmSegment {
  /**
   * A name that uniquely identify the segment
   */
  name: string;

  zone: Zone;
  /**
   * Start position of the segment, in seconds (inclusive)
   */
  start: number;
  /**
   * Start position of the segment, in seconds (exclusive)
   */
  end: number;
}

export interface ControlInterfaceOptions {
  hint: boolean | null;
  questions: boolean | null;
}

export interface FilmReviewServiceUiMethods {
  controlInterface: (options: ControlInterfaceOptions) => void;
  requestToNotShow: () => void;
}

export interface FilmReviewServiceAnsweringMethods {
  upload: () => void;
}

export interface FilmReviewServiceMethods {
  ui: FilmReviewServiceUiMethods;
  answers: FilmReviewServiceAnsweringMethods;
}

export interface FilmReviewServiceData {
  segment: FilmSegment | null;
  questions: Questions | null;
  methods: FilmReviewServiceMethods;
}

export interface FilmReviewService extends VideoPlayerService {
  data: FilmReviewServiceData;
}
